import { Paper as MuiPaper, Popper } from "@mui/material"
import { styled } from "@mui/material/styles"
import React, { useState } from "react"

import { Menu, MuiIcon } from "../../atoms/index"

export const StyledMenuItem = styled(Menu.Item)(() => ({
  borderBottom: "none",
  display: "flex",
  justifyContent: "space-between",
  maxWidth: "100vw",
  width: "100%",
  "&.toolbar-mode": {
    fontWeight: 400,
    padding: "6px 16px",
    lineHeight: "20px",

    "& .MuiSvgIcon-root": {
      width: "20px",
    },
  },
}))

export const NestedMenu = ({ children, maxHeight, maxWidth = "450px", menuGap, open }) => {
  const Paper = styled(MuiPaper)({
    "& li": {
      whiteSpace: "break-spaces",
    },

    border: "1px solid #ebebeb",
    marginTop: menuGap,
    maxHeight,
    maxWidth,
    overflow: "auto",
  })

  return (
    <Paper elevation={8} open={open}>
      {children}
    </Paper>
  )
}

export const NestedRoot = ({ children, handleClick, title, toolbarMode, id }) => {
  const [anchorElement, setAnchorElement] = useState(null)

  const handleMouseEnter = (event) => {
    setAnchorElement(event.currentTarget)
  }

  const handleMouseLeave = () => {
    setAnchorElement(null)
  }

  const open = Boolean(anchorElement)

  return (
    <StyledMenuItem
      className={toolbarMode ? "toolbar-mode" : ""}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      id={id}
      onClick={handleClick}>
      {title}
      <MuiIcon.ArrowRight />
      {open && (
        <Popper
          anchorEl={anchorElement}
          open={open}
          placement="right-start"
          style={{ zIndex: 100 }}>
          <NestedMenu open={open}>{children}</NestedMenu>
        </Popper>
      )}
    </StyledMenuItem>
  )
}
